export default __webpack_public_path__ + "static/media/obra2.26a53516.png";